export const ERROR_CODE = {
    IN_AUDIT: '450108', // '处于对话评测模式中，无法对问答进行增删改操作',
    LOGIN_FAIL: '450006', // 没有登录态
    ROBOT_NOT_EXIST: '450011', // 机器人不存在
    AUTH_FAIL: '450002', // 权限不足
    RESOURCE_FAIL: '450171', // 资源不足, 用户没有数据权限
    INVALID_SHARECODE: '460004' // 分享码已失效
};



// WEBPACK FOOTER //
// ./src/constants/error-code.js